import React from 'react';

import Progress from 'sharedreact/data/Progress';
import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  progress?: Progress,
  language?: string,
  showFinishedIcon?: boolean,
  
  onCancel?: (progressId: string) => void
};

class ProgressBar extends React.Component<Props> {
  constructor (props: Props) {
    super(props);

    this.handleCancel = this.handleCancel.bind(this);
  }
  
  handleCancel (event: React.MouseEvent<HTMLSpanElement>): void {
    const { progress, onCancel } = this.props;

    event.stopPropagation();

    if (progress != null && onCancel != null) {
      onCancel(progress.id);
    }
  }

  override render (): React.ReactNode {
    const { progress, language, showFinishedIcon, onCancel } = this.props;

    if (progress == null) {
      return null;
    }

    const progressValue: number = Math.min(Math.max(0, Math.round(progress.progress != null ? progress.progress : 100)), 100);

    return (
      <div className='esko_cancelable-progress'>
        <div className='esko_progress'>
          <div className={progress.progress != null ? 'esko_progress-bar' : 'esko_progress-bar esko_progress-bar-striped active'}
            role='progressbar'
            style={{width: progressValue + '%'}}
            aria-valuenow={progressValue}
            aria-valuemin={0}
            aria-valuemax={100} />
        </div>
        {showFinishedIcon === true && progressValue >= 100
          ? <span className='esko_progress-finishedicon bi bi-check-circle' />
          : null
        }
        {onCancel != null && progress.progress != null && progressValue < 100
          ? <span className='esko_dropzone-cancel bi bi-x-circle'
            onClick={this.handleCancel}
            title={language ? translate('shared.dropzone.tooltip.cancel') : undefined} />
          : null
        }
      </div>
    );
  }
}

export default ProgressBar;
